export function usePaymentIntentCreatedState() {
    return useState<boolean>('payment_intent_created', () => false)
}
